<template>
  <a-spin :spinning="confirmLoading" :tip="spinTips">

      <j-form-container   style="margin-bottom: 50px;">
        <a-form :form="form" slot="detail">
          <a-row class="form-box">
            <a-col :span="24" v-if="model.ids.split(',').length==1">
              <a-form-item label="项目名称" >
                <j-dict-select-tag :disabled="true" type="list" v-decorator="['businessSegment']" :trigger-change="true" dictCode="business_segment" placeholder="请选择项目名称" />
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="model.ids.split(',').length==1">
              <a-form-item label="工单类型"  >
                <j-search-select-tag
                  :disabled="true"
                  placeholder="请选择工单类型"
                  v-decorator="['workOrderType']"
                  :dictOptions="parentList">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="type==1 || type==5 || type==3">
              <a-form-item :label="type==5?'交付给':'转交给'" >
                <j-search-select-tag
                  :disabled="isDisabled"
                  placeholder="请选择"
                  v-decorator="['transfer', validatorRules.transfer]"
                  :dictOptions="ccList">
                </j-search-select-tag>
              </a-form-item>
            </a-col>

            <a-col :span="24" v-if="model.isCreateBy && model.workOrderStatus in [1,4] && model.backFlag == 1">
              <a-form-item label="回收方式">
                <j-dict-select-tag :disabled="formDisabled" type="list"
                                   @change="switchType"
                                   v-decorator="['backType', validatorRules.backType]" :trigger-change="true" dictCode="back_type" placeholder="请选择回收方式" />
              </a-form-item>
            </a-col>

            <a-col :span="24" v-if="model.isCreateBy && model.workOrderStatus in [1,4] && model.backType == 1  && model.backFlag == 1">
              <a-form-item label="倒计时">
                <a-input-number :formatter="(value) => `${value}`"
                                :precision="0"
                                :parser="(value) => value.replace('.', '')" :min="0" :max="999" :maxLength="3"  v-model="model.day"  style="width: 100px"></a-input-number>
                <span style="margin: 0 10px">天</span>
                <a-input-number  :formatter="(value) => `${value}`"
                                 :precision="0"
                                 :parser="(value) => value.replace('.', '')" :min="0" :max="23" :maxLength="2" v-model="model.hour"  style="width: 100px"></a-input-number>
                <span style="margin: 0 10px">小时</span>
                <a-input-number   :formatter="(value) => `${value}`"
                                  :precision="0"
                                  :parser="(value) => value.replace('.', '')" :min="0" :max="59" :maxLength="2" v-model="model.minutes"  style="width: 100px"></a-input-number>
                <span style="margin: 0 10px">分钟</span>
              </a-form-item>
            </a-col>

            <a-col :span="24" v-if="model.isCreateBy && model.workOrderStatus in [1,4]&&model.backType == 2  && model.backFlag == 1">
              <a-form-item label="指定日期">
                <a-date-picker show-time placeholder="请选择指定日期"  v-decorator="['backTime']"/>
              </a-form-item>
            </a-col>
            <!--<a-col :span="24" v-if="model.ids.split(',').length==1">-->
            <!--<a-form-item label="传达类型"  >-->
            <!--<j-search-select-tag-->
            <!--placeholder="请选择传达类型"-->
            <!--v-decorator="['workOrderTypeChild', validatorRules.workOrderTypeChild]"-->
            <!--:dictOptions="typeChildList">-->
            <!--</j-search-select-tag>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="24">
              <a-form-item label="备注">
                <a-textarea  :disabled="formDisabled"  v-decorator="['remark', validatorRules.remark]" rows="4" placeholder="请输入备注" />
              </a-form-item>
              <!--<div class="phrases-box" v-if="phrases">-->
              <!--<div v-for="it in workorder_phrases" v-if="it.value.indexOf(phrases)!=-1 && it.value!=phrases" @click="choosePhrases(it.value)" v-html="formatSearchConetnt(it.value,phrases)">-->
              <!--</div>-->

              <!--</div>-->
            </a-col>
            <div ref="pasteContainer">
            <a-col :span="24" >
              <a-form-item label="图片附件">
                <j-image-upload :disabled="disabled" :width="0" :height="0" :number="6" :isMultiple="true"  bizPath="imageFile"    v-decorator="['imageFile']" ></j-image-upload>
              </a-form-item>

            </a-col>
            <a-col :span="24" >
              <a-form-item label="视频附件">
                <j-upload  :disabled="disabled"  fileType="mp4" :number="3" :isMultiple="true"  bizPath="imageVideo_videoUrl_notzip"    v-decorator="['videoUrl']" ></j-upload>
              </a-form-item>
            </a-col>
            </div>
          </a-row>

        </a-form>
      </j-form-container>


  </a-spin>
</template>

<script>
  import { formatSearchConetnt ,by_str} from '@/utils/util'
  import { httpAction, getAction,postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import axios from 'axios';
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { validateDuplicateValue } from '@/utils/util'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
import { getAccessToken } from '@/utils/token'
  export default {
    name: 'DmZjWorkOrderForm',
    components: {
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        validatorRules: {
          transfer: {
            rules: [
              { required: true, message: '请选择!'},

            ]
          },
          remark: {
            rules: [
              { required: true, message: '请填写备注!'},
            ]
          },
          workOrderType:{
            rules: [
              { required: true, message: '请选择工单类型!'},
            ]
          },
          businessSegment:{
            rules: [
              { required: true, message: '请选择业务板块!'},
            ]
          }
        },
        url: {
          add: "/dm/dmWorkOrder/closeOrder",
          remark: "/dm/dmWorkOrder/remark",
          edit: "/dm/dmWorkOrder/edit",
          queryById: "/dm/dmWorkOrder/queryById",
          finish: "/dm/dmWorkOrder/finishOrder",
        },ccList:[],
        showWork:false,
        type:1,
        isDisabled:false,
        dictOptionsType:{},
        workorder_phrases:[],
        formatSearchConetnt:formatSearchConetnt,
        phrases:'',
        parentList:[],
        typeChildList:[],
        spinTips:''
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data

      //this.showFlowData();
      this.getCcList();
      this.initDictPh();
      this.getParentList();



    },
    destroyed() {
      console.log('粘贴事件触发beforeDestroy')
      // 移除事件监听，防止内存泄漏
      this.$refs.pasteContainer.removeEventListener('paste', this.handlePaste);
    },
    methods: {
      /**
       * 处理粘贴事件
       * @param {ClipboardEvent} e 粘贴事件对象
       */
      handlePaste(e) {
        console.log('粘贴事件触发')
        // 阻止默认粘贴行为（避免文本粘贴到页面）
        e.preventDefault();
        // 提取剪贴板中的文件列表
        const files = e.clipboardData?e.clipboardData.files:null;
        if (!files || files.length === 0) {
          return;
        }
        // 取第一个文件（如需多文件上传，可遍历files）
        const file = files[0];
        console.log('粘贴的文件：', file);//mp4,av
        // 图片文件预览（非图片文件可跳过）
        if (file.type.indexOf('image/') === -1 && file.type.indexOf('video/') === -1) {
          // const reader = new FileReader();
          // reader.onload = (e) => {
          //   this.filePreview = e.target.result;
          // };
          // reader.readAsDataURL(file);
          return;
        }
        this.uploadFile(file)

      },
       add (record) {
         this.type= record.type;
         if(record.isJf){
           this.isDisabled = true;
         }else{
           this.isDisabled = false;
         }
         this.typeChildList = []
        this.initDictConfig();
        this.edit(record);

      },
      async initDictConfig(){
        //初始化字典
      await  initDictOptions('work_order_type').then((res) => {
          if (res.success) {
            this.dictOptionsType = res.result;
          }
        });
      },  initDictPh(){
        //初始化字典
       initDictOptions('workorder_phrases').then((res) => {
          if (res.success) {
            this.workorder_phrases = res.result;
          }
        });
      },
      customRender(text){
        //字典值替换通用方法
        return filterDictText(this.dictOptionsType, text);
      },
      async edit (record) {
         console.log(record)
        record.ids = record.ids+"";
        if(record.ids.split(",").length==1){
          this.showWork = true
          await this.showFlowData(record);
        }else{
          this.form.resetFields();
          record.backType=0;
          record.backTime = null;
          record.countdown = null;
          this.model = Object.assign({}, record);

          this.visible = true;
          if(this.model.workOrderType){
            this.model.phrases = this.customRender(this.model.workOrderType);
            this.getChildList();
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'workOrderType','workOrderTypeChild','businessSegment','phrases','transfer','remark','imageFile','videoUrl'))
          })
        }

        this.$nextTick(() => {
          console.log('粘贴事件触发created',this.$refs.pasteContainer)
          this.$refs.pasteContainer.addEventListener('paste', this.handlePaste);
        });
      },
      //渲染流程表单数据
      async showFlowData(record){
         let that = this;
         await getAction("/dm/dmWorkOrder/queryInfoById",{"id":record.ids}).then((res)=>{
           if(res.success){
             record.workOrderType = res.result.workOrderType
             record.businessSegment = res.result.businessSegment
             record.backType=0;
             record.backTime = null;
             record.countdown = null;
             record.isCreateBy = res.result.isCreateBy
             record.backFlag =  res.result.backFlag!=0?1:0;
             that.form.resetFields();
             that.model = Object.assign({}, record);
             console.log(this.model)
             that.visible = true;
             if(this.model.workOrderType){
               this.model.phrases = this.customRender(this.model.workOrderType);
               this.getChildList();
             }

             that.$nextTick(() => {
               that.form.setFieldsValue(pick(that.model,'workOrderType','workOrderTypeChild','businessSegment','phrases','transfer','remark','imageFile','videoUrl'))
             })
           }
         });
      },
     async submitForm () {
        await this.submit();
      },submit(){
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            // if(this.type==1&&!values.remark){
            //   that.$message.warning("请填写备注");
            //   return;
            // }
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(that.type==1){
              httpurl+=this.url.edit;
              method = 'put';
            }else if(that.type==4){
              httpurl+=this.url.remark;
              method = 'put';
            }else if(that.type==5){
              httpurl+=this.url.finish;
              method = 'post';
            }else{
              httpurl+=this.url.add;
              method = 'post';
            }

            let formData = Object.assign(this.model, values);
            if(formData.backType==1){
              if(!formData.day && !formData.hour && !formData.minutes){
                that.$message.error("请输入倒计时");
                return
              }
              formData.countdown = (formData.day?formData.day:0)+"-"+(formData.hour?formData.hour:0)+"-"+(formData.minutes?formData.minutes:0);
            }else if(formData.backType==2){
              if(!formData.backTime){
                that.$message.error("请选择固定时间");
                return
              }
            }
            let ArrList = [];

            if(formData.imageFile){
              let imageFileArr = formData.imageFile.split(",");
              for(let a in imageFileArr){
                ArrList.push({
                  fileUrl:imageFileArr[a],
                  coverImg:"",
                  duration:0,
                  fileType:1
                })
              }
            }
            if(formData.videoUrl){
              let videoUrlArr = formData.videoUrl.split(",");
              for(let a in videoUrlArr){
                ArrList.push({
                  fileUrl:videoUrlArr[a],
                  coverImg:videoUrlArr[a].substring(0,videoUrlArr[a].lastIndexOf("."))+".jpg",
                  duration:0,
                  fileType:2
                })
              }
            }
            if(ArrList.length>0){
              formData.videoUrl = JSON.stringify(ArrList);
            }
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok',formData.workOrderId);
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'workOrderType','businessSegment','workOrderTypeChild','phrases','transfer','remark','imageFile'))
      },
      getCcList(){
        var that =this;
        that.ccList = [];
        getAction("/sys/user/queryAllList",{"permissionId":"1543471348594860033"}).then((res)=>{
          if(res.success){
            let ccList = res.result;
            if(ccList){
              ccList.sort(by_str("sortNum")).reverse();
              for(var k in ccList){
                that.ccList.push({
                  text:ccList[k].realname,
                  value:ccList[k].username
                });
              }

            }
          }
        });
      },changeRemark(val){
         let txt = val.target._value;
         if(txt){
           if(txt.charAt(0)=='['){
             this.phrases=''
           }else{
             this.phrases = txt;
           }
         }else{
           this.phrases=''
         }
      },choosePhrases(ph){
        this.model.remark = ph;
        this.phrases = ''
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'remark'))
        })
      },
      getParentList(){
        getAction("/dm/dmWorkOrderType/listAll",{}).then(res=>{
          if(res.success){
            let list = res.result;
            if (list) {
              for (var k in list) {
                this.parentList.push({
                  text: list[k].name,
                  value: list[k].id
                });
              }

            }
          }
        });
      },
      async getChildList(){
        this.typeChildList = []
       await  getAction("/dm/dmWorkTrackType/listByTypeId",{typeId:this.model.workOrderType}).then(res=>{
          if(res.success){
            let list = res.result;
            if (list) {
              for (var k in list) {
                this.typeChildList.push({
                  text: list[k].name,
                  value: list[k].id
                });
              }

            }
          }
        });
      },switchType(type){
        this.model.backType = type;
      }, /**
       * 上传文件到服务器
       * @param {File} file 要上传的文件
       */
      async uploadFile(file) {
        try {
          this.confirmLoading = true;
          this.spinTips = "上传中...";
          // 封装FormData（后端需接收multipart/form-data类型）
          const formData = new FormData();
          formData.append('file', file); // 后端通过"file"获取文件
          const token = getAccessToken();
          // 发送上传请求（替换为你的后端接口）
          const response = await axios.post(window._CONFIG['domianURL']+"/sys/common/upload", formData, {
            headers: {
              "X-Access-Token":token
            },
            onUploadProgress: (progressEvent) => {
              // 可选：处理上传进度
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              this.spinTips=`上传进度：${percent}%`;
            }
          });
          if(file.type.indexOf("image/")!==-1){
            // 上传成功处理
            if(this.model.imageFile){
              this.model.imageFile = this.model.imageFile+","+response.data.message;
            }else{
              this.model.imageFile = response.data.message;
            }

            this.form.setFieldsValue(pick(this.model,'imageFile'))
          }else{
            if(this.model.videoUrl){
              this.model.videoUrl = this.model.videoUrl+","+response.data.message;
            }else{
              this.model.videoUrl = response.data.message;
            }
            this.form.setFieldsValue(pick(this.model,'videoUrl'))
          }


        } catch (error) {
          console.error(error);
          // 上传失败处理
          this.$message.error("文件上传失败，请重试！");
        } finally {
          this.confirmLoading = false;
          this.spinTips = "";
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/ .ant-col-xs-24{
    float: inherit;
  }
  /deep/ .ant-form-item{
    margin-bottom: 0px !important;
  }

  .form-box{
    padding:24px;
  }
  .phrases-box{
    max-height: 400px;
    background:rgba(229, 229, 229, 1);
    color: rgba(56, 56, 56, 1);
    margin-top: -10px;
    padding-top: 10px;

  }
  .phrases-box div{
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }
  /deep/ .ant-input{
    background: #fff !important;
  }
  /deep/ .ant-select-selection{
    background: #fff !important;
  }


  /deep/ .ant-input-disabled{
    background: #E6EDF5 !important;
  }

  /deep/ .ant-select-selection__rendered{
    line-height:36px !important;
    height: 36px !important;
  }

  /deep/ .ant-select-selection--single{
    border-radius: 18px !important;
  }

</style>
